import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileIQC from './MobileIQC';

const TRCManagement = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('iqc');

  const tabs = [
    { id: 'iqc', name: 'Initial Quality Check (IQC)', icon: '🔍' },
    { id: 'devices', name: 'Device List', icon: '📱' },
    { id: 'repairs', name: 'Repairs in Progress', icon: '🔧' },
    { id: 'fqc', name: 'Final Quality Check (FQC)', icon: '✅' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'iqc':
        return <MobileIQC user={user} />;
      case 'devices':
        return <DeviceList />;
      case 'repairs':
        return <RepairsInProgress />;
      case 'fqc':
        return <FinalQualityCheck />;
      default:
        return <MobileIQC user={user} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">TRC Management</h1>
              <p className="text-sm text-gray-600 mt-1">Technical Repair Center - Device Quality & Repair Workflow</p>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/dashboard')}
                className="px-4 py-2 text-gray-700 hover:text-gray-900"
              >
                Dashboard
              </button>
              <button
                onClick={onLogout}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex space-x-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 text-sm font-medium transition-all ${
                  activeTab === tab.id
                    ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="max-w-7xl mx-auto">
        {renderTabContent()}
      </div>
    </div>
  );
};

// Placeholder components for other tabs
const DeviceList = () => (
  <div className="p-6">
    <div className="bg-white rounded-lg shadow-sm p-8 text-center">
      <div className="text-6xl mb-4">📱</div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">Device List</h3>
      <p className="text-gray-600">View all devices in TRC with their current status and location</p>
      <p className="text-sm text-gray-500 mt-4">Coming soon...</p>
    </div>
  </div>
);

const RepairsInProgress = () => (
  <div className="p-6">
    <div className="bg-white rounded-lg shadow-sm p-8 text-center">
      <div className="text-6xl mb-4">🔧</div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">Repairs in Progress</h3>
      <p className="text-gray-600">Track ongoing repairs, assign engineers, and monitor progress</p>
      <p className="text-sm text-gray-500 mt-4">Coming soon...</p>
    </div>
  </div>
);

const FinalQualityCheck = () => (
  <div className="p-6">
    <div className="bg-white rounded-lg shadow-sm p-8 text-center">
      <div className="text-6xl mb-4">✅</div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">Final Quality Check (FQC)</h3>
      <p className="text-gray-600">Perform final quality checks before marking devices as Ready For Sale</p>
      <p className="text-sm text-gray-500 mt-4">Coming soon...</p>
    </div>
  </div>
);

export default TRCManagement;
